import { render, staticRenderFns } from "./index.vue?vue&type=template&id=66cc0cb0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cc0cb0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\privateItem\\sct-shop\\sct-shop-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66cc0cb0')) {
      api.createRecord('66cc0cb0', component.options)
    } else {
      api.reload('66cc0cb0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=66cc0cb0&scoped=true", function () {
      api.rerender('66cc0cb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/certificate/index.vue"
export default component.exports